import { apiFetchV2 } from '@m/utils/http';

import type { EvaluationContext } from '@m/services/experimentation/EvaluationContext';

export type { EvaluationContext };

export interface ExperimentResponse {
  group: string;
  name: string;
  parameters: Record<string, unknown>;
}

export interface StableIdAssociationResponse {
  stableId: string;
  userId: number;
}

export const CONTROL_RESPONSE = (name: string): ExperimentResponse => ({
  name,
  group: 'control',
  parameters: {},
});

export const ExperimentService = {
  associateStableId: (stableId: string) =>
    apiFetchV2<StableIdAssociationResponse>('/experiment/stable-id-association', {
      method: 'POST',
      body: { stableId },
    }),
  getExperiment: (
    experimentName: string,
    evaluationContext?: EvaluationContext,
    signal?: AbortSignal,
  ) =>
    apiFetchV2<ExperimentResponse>('/experiment', {
      method: 'POST',
      body: { experimentName, evaluationContext },
      signal,
    }),
};
